import { EventEmitter } from "@angular/core";

export class SelectListItemModel {
	selected: boolean;
	value: string | number | object;
	name: string;
	private _highlight: boolean = false;
	set highlight(value: boolean) { this.highlightChange.next(this._highlight = value);	}
	get highlight() { return this._highlight; }
	highlightChange = new EventEmitter<boolean>();

	constructor(value: string | number | object, name: string, selected: boolean = false) {
		this.value = value;
		this.name = name;
		this.selected = selected;
	}
}

export const sortSelectList = function(selectList: Array<SelectListItemModel>) {
	if (selectList && selectList.length > 0) {
		if (!selectList.some(listItem => isNaN(Number(listItem.name)))) {
			selectList.sort((listItemA, listItemB) => {
				return Number(listItemA.name) - Number(listItemB.name);
			});
		} else if (!selectList.some(listItem => isNaN(Number(listItem.value)))) {
			selectList.sort((listItemA, listItemB) => {
				return Number(listItemA.value) - Number(listItemB.value);
			});
		} else {
			selectList.sort((listItemA, listItemB) => {
				return listItemA.name.localeCompare(listItemB.name);
			});
		}
	}
}
